import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

import { ModalContent } from './Modal.styled';

export const GifWrapper = styled.div`
	cursor: pointer;
`;

export const GifModal = styled(ModalContent)`
	padding-top: 3rem;

	@media ${Breakpoints.tablet} {
		padding-top: 5rem;
	}
`;
